require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2006-06-19-testing-testing-1-2-3.json") })
        }
      }, "path---articles-2006-06-19-testing-testing-1-2-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2006-06-19-testing-testing-1-2-3!./.cache/json/articles-2006-06-19-testing-testing-1-2-3.json
// module id = 470
// module chunks = 231608221292675